import { type ModalRegistration } from '@/shared/components/Modals/modal-registry/modal-registry.types';

import { AiRateEditorModal } from '../components/AiRateEditorModal/AiRateEditorModal';
import { ProviderConfigModal } from '../components/ProviderConfigModal/ProviderConfigModal';

/**
 * The module's dialog TYPES.
 *
 * Global strings, so they carry the module name: the registry throws on a
 * collision rather than letting whichever registered last silently win.
 */
export const INTEGRATIONS_MODALS = {
  PROVIDER_CONFIG: 'integrations.provider-config',
  AI_RATE: 'integrations.ai-rate',
} as const;

/**
 * The registrations `app.config.tsx` installs.
 *
 * The payload is the capability and provider **keys** — serializable, and the
 * modal loads everything else from its own query, which is what keeps an open
 * dialog correct while the overview refetches underneath it.
 */
export const integrationsModals: readonly ModalRegistration[] = [
  { modalTypes: [INTEGRATIONS_MODALS.PROVIDER_CONFIG], component: ProviderConfigModal },
  { modalTypes: [INTEGRATIONS_MODALS.AI_RATE], component: AiRateEditorModal },
];
